// extracted by mini-css-extract-plugin
export var container = "styles-module--container--b9fwc";
export var item = "styles-module--item--zb+Tp";
export var section = "styles-module--section--Hyy1I";
export var text = "styles-module--text--hNF+K";
export var uspText = "styles-module--uspText--9EpT5";